/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Restore_TitleInputs */



/**
* | output |
* | --- |
* | "Restore this round?" |
*
* @param {Rounds_Restore_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_title = /** @type {((inputs?: Rounds_Restore_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer cette ronde ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Restaurar esta ronda?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Restaurar esta rodada?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristinare questo round?")
	return /** @type {LocalizedString} */ ("Restore this round?")
});